<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between align-items-start mb-0 flex-wrap">
          <h1 class="text-bold-400" style="color: #4e7977">
            Servidores
            <!-- Admin: nome do município clicável abre a modal de troca -->
            <a
              *ngIf="isAdmin; else tituloCidade"
              class="cidade-trocar"
              role="button"
              (click)="openModalMunicipios(modalMunicipios)"
              title="Clique para trocar de município"
            >
              {{ nomeCidade }}
              <i class="ft-search ml-1"></i>
            </a>
            <ng-template #tituloCidade>{{ nomeCidade }}</ng-template>
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os servidores públicos do seu município.
          Utilize a busca e os filtros para encontrar e atualizar informações de
          forma eficiente.
        </p>
      </div>
    </div>

    <form #servForm="ngForm" (ngSubmit)="applyFilters()" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px">Nome</label>
              <input
                type="text"
                id="nome"
                class="form-control"
                [(ngModel)]="filterName"
                name="nome"
                placeholder="Procure por nome"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="cpf" style="font-size: 14px">CPF</label>
              <input
                type="text"
                id="cpf"
                class="form-control"
                [(ngModel)]="filterCpf"
                name="cpf"
                placeholder="Digite um cpf"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="matricula" style="font-size: 14px">Matrícula</label>
              <input
                type="text"
                id="matricula"
                class="form-control"
                [(ngModel)]="filterMatricula"
                name="matricula"
                placeholder="Digíte uma matrícula"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="filtros_diversos" style="font-size: 14px"
                >Filtros diversos</label
              >
              <ng-select
                [items]="filtrosDiversosOpcoes"
                name="filtros_diversos"
                bindLabel="name"
                bindValue="id"
                placeholder="Selecione"
                id="filtros_diversos"
                [(ngModel)]="filterDiverso"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="status" style="font-size: 14px">Status</label>
              <ng-select
                [items]="statusServidor"
                name="status"
                bindLabel="name"
                bindValue="id"
                placeholder="Selecione"
                id="status"
                [(ngModel)]="filterStatus"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="data_cadastro" style="font-size: 14px"
              >Data de cadastro</label
            >
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="date"
                  id="data_cadastro"
                  class="form-control"
                  [(ngModel)]="filterCreatedAt.start"
                  name="data_cadastro"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="date"
                  id="data_nascimento"
                  class="form-control"
                  [(ngModel)]="filterCreatedAt.end"
                  name="data_nascimento"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="data_nascimento" style="font-size: 14px"
              >Data de nascimento</label
            >
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="date"
                  id="data_nascimento"
                  class="form-control"
                  [(ngModel)]="filterBirthDate.start"
                  name="data_nascimento"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="date"
                  id="data_nascimento"
                  class="form-control"
                  [(ngModel)]="filterBirthDate.end"
                  name="data_nascimento"
                  placeholder="dd-mm-yyyy"
                  required
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="submit"
          class="btn btn-outline-primary mb-2 mb-md-0"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>
    </form>

    <hr class="my-3" />

    <div class="form-row d-flex justify-content-end">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="openModalXl(cadastroServidor)"
        >
          <i class="fa fa-plus mr-2"></i>Adicionar Servidor
        </button>
      </div>
    </div>
  </div>
</div>

<!-- LISTAGEM SERVIDORES -->
<div class="card servidores-lista" style="border-radius: 10px">
  <table class="table text-center" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('cpf')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            CPF
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('cpf')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('cpf')"
                class="fa"
                [ngClass]="getSortIcon('cpf')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('matricula')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Matrícula(s)
            <div class="sort-icons ml-1">
              <i
                *ngIf="!isColumnSorted('matricula')"
                class="fa fa-caret-up"
              ></i>
              <i
                *ngIf="!isColumnSorted('matricula')"
                class="fa fa-caret-down"
              ></i>
              <i
                *ngIf="isColumnSorted('matricula')"
                class="fa"
                [ngClass]="getSortIcon('matricula')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('status')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Status
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('status')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('status')"
                class="fa"
                [ngClass]="getSortIcon('status')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let servidor of servidoresFiltered; let index = index">
        <tr
          class="servidor-grupo"
          [class.servidor-grupo-alternado]="index % 2 !== 0"
          [class.servidor-grupo-aberto]="isServidorExpanded(servidor)"
          role="button"
          tabindex="0"
          (click)="toggleServidor(servidor)"
          (keydown.enter)="toggleServidor(servidor)"
          (keydown.space)="$event.preventDefault(); toggleServidor(servidor)"
          [attr.aria-expanded]="isServidorExpanded(servidor)"
          [attr.aria-label]="(isServidorExpanded(servidor) ? 'Recolher' : 'Expandir') + ' matrículas de ' + servidor.nome"
        >
          <td class="pl-3 pr-3">
            <div class="d-flex align-items-center servidor-identificacao">
              <span
                class="servidor-toggle"
                [attr.aria-expanded]="isServidorExpanded(servidor)"
                aria-hidden="true"
              >
                <i
                  [ngClass]="isServidorExpanded(servidor) ? 'ft-chevron-down' : 'ft-chevron-right'"
                ></i>
              </span>
              <img
                width="50"
                height="50"
                alt="datatable-avatar"
                class="square rounded-circle"
                [ngClass]="{ 'cursor-pointer': servidor && servidor.imagem }"
                (click)="$event.stopPropagation(); servidor && servidor.imagem ? viewMidia(servidor.imagem, contentImg) : null"
                [src]="servidor && servidor.imagem ? servidor.imagem : 'assets/img/portrait/small/no-avatar.svg'"
              />
              <div>{{ servidor.nome }}</div>
            </div>
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            {{ servidor.cpf | mask : "000.000.000-00" }}
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            {{ getMatriculasServidor(servidor).length }}
          </td>
          <td class="pl-0 pr-0 text-center align-middle">
            <span
              *ngFor="let status of getStatusServidor(servidor)"
              class="status-servidor"
              [ngClass]="getStatusClass(status)"
            >
              {{ classificaStatus(status) }}
            </span>
          </td>
          <td class="align-middle servidor-acoes" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="d-flex justify-content-end align-items-center">

              <button
                type="button"
                class="btn btn-outline-primary btn-sm mr-1 visualizar-servidor"
                routerLink="/page/servidorv2"
                [queryParams]="{ id: servidor.id, idCidade: idCidade, id_matricula: servidor.id_matricula }"
                title="Visualizar"
                aria-label="Visualizar servidor"
              >
                <i class="fa fa-eye"></i>
              </button>
              <div class="dropdown btn-group" ngbDropdown placement="bottom-right">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm dropdown-toggle"
                  ngbDropdownToggle
                >
                  Mais ações
                </button>
                <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
                  <button type="button" class="dropdown-item" (click)="getRelatorioServidor(relatorio, servidor.id)">
                    <i class="fa fa-file-text-o mr-2"></i>Relatório
                  </button>
                  <button type="button" class="dropdown-item text-danger" (click)="deletarServidor(servidor)">
                    <i class="fa fa-trash mr-2"></i>Excluir
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr class="servidor-matricula" *ngFor="let matricula of getMatriculasServidor(servidor)" [hidden]="!isServidorExpanded(servidor)">
          <td class="text-left align-middle"><span class="matricula-label">Matrícula</span></td>
          <td></td>
          <td class="text-center align-middle">{{ matricula.matricula || '-' }}</td>
          <td class="text-center align-middle">
            <span class="status-servidor" [ngClass]="getStatusClass(matricula.status)">
              {{ classificaStatus(matricula.status) || '-' }}
            </span>
          </td>
          <td class="text-right align-middle matricula-acoes">
            <div class="d-inline-flex align-items-center">
              <a
                routerLink="/page/servidorv2"
                [queryParams]="{ id: servidor.id, id_matricula: matricula.id, secao: 'matriculas' }"
                class="ver-detalhes"
              >
                Ver detalhes
              </a>
              <button
                *ngIf="isAdmin"
                type="button"
                class="btn btn-link text-danger remover-matricula-temporaria"
                title="Remover matrícula"
                [attr.aria-label]="'Remover matrícula ' + (matricula.matricula || '')"
                (click)="removerMatricula(servidor, matricula)"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-container>

    </tbody>
  </table>
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="total > 0"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="2"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="total"
      (pageChange)="onPageChange()"
    ></ngb-pagination>
  </div>
</div>
<div class="row" *ngIf="total == 0 && !servidoresFiltered.length">
  <div class="col">
    <div class="card-content">
      <div class="card-body">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="media">
              <div class="media-body">
                <h5 class="mt-0">Nenhum servidor encontrado.</h5>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Modal de seleção de município (admin) -->
<ng-template #modalMunicipios let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Selecionar município</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fa fa-search"></i></span>
      </div>
      <input
        type="text"
        class="form-control"
        placeholder="Buscar município..."
        [(ngModel)]="filtroMunicipio"
        [ngModelOptions]="{ standalone: true }"
        autocomplete="off"
      />
    </div>
    <div class="list-group municipios-lista">
      <button
        type="button"
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        *ngFor="let m of municipiosFiltrados()"
        [class.active]="m.id == idCidade"
        (click)="trocarCidade(m.id)"
      >
        {{ m.nome }}
        <i class="fa fa-check" *ngIf="m.id == idCidade"></i>
      </button>
      <div
        class="text-muted text-center py-3"
        *ngIf="municipiosFiltrados().length === 0"
      >
        Nenhum município encontrado.
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cadastroServidor let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Novo Servidor</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #servForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="alert alert-info" role="alert">
            <i class="ft-info"></i>
            <strong>Informação:</strong> Depois de cadastrar o servidor, use
            <strong>Adicionar matrícula</strong> na ficha para incluir outros
            vínculos.
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="escolaridade" style="font-size: 14px"
                >Status <b style="color: red">*</b></label
              >
              <ng-select
                [items]="statusServidor"
                name="status"
                bindLabel="name"
                bindValue="id"
                placeholder="Status"
                id="status"
                [(ngModel)]="servidor.status"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px"
                >Nome <b style="color: red">*</b></label
              >
              <input
                type="text"
                id="nome"
                class="form-control"
                [(ngModel)]="servidor.nome"
                name="nome"
                placeholder="Nome Completo"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="data_nascimento" style="font-size: 14px"
                >Nascimento</label
              >
              <input
                type="text"
                id="data_nascimento"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.data_nascimento"
                name="data_nascimento"
                placeholder="Data Nascimento"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="sexo" style="font-size: 14px">Sexo</label>
              <ng-select
                [items]="sexos"
                name="sexo"
                bindLabel="name"
                placeholder="Sexo"
                bindValue="id"
                id="sexo"
                [(ngModel)]="servidor.sexo"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px">Estado</label>
              <ng-select
                [items]="estados"
                name="estado"
                (change)="toggleEstado()"
                bindLabel="estado"
                bindValue="estado"
                placeholder="Estado"
                id="estado"
                [(ngModel)]="servidor.estado_naturalidade"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px">Cidade</label>
              <ng-select
                [items]="cidades"
                [disabled]="!cidades || cidades.length == 0"
                name="cidade"
                bindLabel="nome"
                bindValue="id"
                placeholder="Cidade"
                id="cidade"
                [(ngModel)]="servidor.cidade_naturalidade"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nacionalidade" style="font-size: 14px"
                >Nacionalidade</label
              >
              <input
                type="text"
                id="nacionalidade"
                class="form-control"
                [(ngModel)]="servidor.nacionalidade"
                name="nacionalidade"
                placeholder="Nacionalidade"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="naturalizado" style="font-size: 14px"
                >Naturalizado</label
              >
              <ng-select
                [items]="naturalizados"
                name="naturalizado"
                bindLabel="name"
                placeholder="Naturalizado"
                bindValue="id"
                id="naturalizado"
                [(ngModel)]="servidor.naturalizado"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="estado_civil" style="font-size: 14px"
                >Estado Civil</label
              >
              <ng-select
                [items]="estadosCivis"
                name="estado_civil"
                bindLabel="descricao"
                bindValue="id"
                placeholder="Estado Civil"
                id="estado_civil"
                [(ngModel)]="servidor.estado_civil"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="escolaridade" style="font-size: 14px"
                >Escolaridade</label
              >
              <ng-select
                [items]="escolaridades"
                name="escolaridade"
                bindLabel="descricao"
                bindValue="id"
                placeholder="Escolaridade"
                id="escolaridade"
                [(ngModel)]="servidor.escolaridade"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="mae" style="font-size: 14px">Nome Mãe</label>
              <input
                type="text"
                id="mae"
                class="form-control"
                [(ngModel)]="servidor.nome_mae"
                name="mae"
                placeholder="Nome Mãe"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="pai" style="font-size: 14px">Nome Pai</label>
              <input
                type="text"
                id="pai"
                class="form-control"
                [(ngModel)]="servidor.nome_pai"
                name="pai"
                placeholder="Nome Pai"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="cpf" style="font-size: 14px">CPF</label>
              <input
                type="text"
                id="cpf"
                class="form-control"
                [(ngModel)]="servidor.cpf"
                mask="000.000.000-00"
                name="cpf"
                placeholder="CPF"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>

        <div
          class="col"
          *ngIf="
            servidor &&
            servidor.status &&
            servidor.status != 2 &&
            servidor.status != 3
          "
        >
          <div class="form-group">
            <div class="controls">
              <label for="data_ingresso" style="font-size: 14px"
                >Data de admissão</label
              >
              <input
                type="text"
                id="data_ingresso"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.data_ingresso_servico_publico"
                name="data_ingresso"
                placeholder="Data de Admissão"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div
          class="col"
          *ngIf="
            servidor &&
            servidor.status &&
            servidor.status != 1 &&
            servidor.status != 2 &&
            servidor.status != 3
          "
        >
          <div class="form-group">
            <div class="controls">
              <label for="docingresso" style="font-size: 14px"
                >Documento de Ingresso</label
              >
              <input
                type="text"
                id="docingresso"
                class="form-control"
                [(ngModel)]="servidor.documento_ingresso_servico_publico"
                name="docingresso"
                placeholder="Documento de Ingresso"
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="naturalizado" style="font-size: 14px"
                >Pessoa com deficiência - PCD</label
              >
              <ng-select
                [items]="naturalizados"
                name="deficiente"
                bindLabel="name"
                placeholder="Deficiente"
                bindValue="id"
                id="deficiente"
                [(ngModel)]="servidor.deficiente"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 2"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="valoraposentadoria" style="font-size: 14px"
                >Valor Atual da Aposentadoria</label
              >
              <input
                type="text"
                id="valoraposentadoria"
                class="form-control"
                prefix="R$"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                [dropSpecialCharacters]="false"
                [(ngModel)]="servidor.valor_aposentadoria"
                name="valoraposentadoria"
                placeholder="Valor Atual da Aposentadoria"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="naturalizado" style="font-size: 14px"
                >Tipo de Aposentadoria</label
              >
              <ng-select
                [items]="tiposaposentadoria"
                name="deficiente"
                bindLabel="name"
                groupBy="group"
                placeholder="Tipo de Aposentadoria"
                bindValue="value"
                id="tiposaposentadoria"
                [(ngModel)]="servidor.tipo_aposentadoria"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="valoraposentadoria" style="font-size: 14px"
                >Cargo em que aposentou</label
              >
              <input
                type="text"
                id="cargo"
                class="form-control"
                [(ngModel)]="servidor.cargo_aposentadoria"
                name="cargo"
                placeholder="Cargo em que aposentou"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="pis_pasep" style="font-size: 14px"
                >PIS do Aposentado</label
              >
              <input
                type="text"
                id="pis_pasep"
                class="form-control"
                [(ngModel)]="servidor.pis_aposentado"
                mask="0*"
                name="pis_pasep"
                placeholder="PIS do Aposentado"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 2"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="data_ingresso" style="font-size: 14px"
                >Data de Ingresso no Serviço Público</label
              >
              <input
                type="text"
                id="data_ingresso"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.data_ingresso_servico_publico"
                name="data_ingresso"
                placeholder="Data de Ingresso no Serviço Público"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="data_concessao" style="font-size: 14px"
                >Data de Concessão do Benefício</label
              >
              <input
                type="text"
                id="data_concessao"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.concessao_aposentadoria"
                name="data_concessao"
                placeholder="Data de Concessão do Benefício"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="paridade" style="font-size: 14px">Paridade</label>
              <ng-select
                [items]="naturalizados"
                name="paridade"
                bindLabel="name"
                placeholder="Paridade"
                bindValue="id"
                id="paridade"
                [(ngModel)]="servidor.paridade_aposentadoria"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 3"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="valor_beneficio" style="font-size: 14px"
                >Valor do Benefício</label
              >
              <input
                type="text"
                id="valor_beneficio"
                class="form-control"
                prefix="R$"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                [dropSpecialCharacters]="false"
                [(ngModel)]="servidor.valor_beneficio"
                name="valor_beneficio"
                placeholder="Valor do Benefício"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="tipo_pensao" style="font-size: 14px"
                >Tipo de Pensão</label
              >
              <ng-select
                [items]="tipospensao"
                name="tipo_pensao"
                bindLabel="name"
                placeholder="Tipo de Pensão"
                bindValue="value"
                id="tipo_pensao"
                [(ngModel)]="servidor.tipo_pensao"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="matricula_beneficiario" style="font-size: 14px"
                >Matrícula do Beneficiário</label
              >
              <input
                type="text"
                id="matricula_beneficiario"
                class="form-control"
                [(ngModel)]="servidor.matricula"
                name="matricula"
                placeholder="Matrícula do Beneficiário"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 3"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="data_falecimento_pensao" style="font-size: 14px"
                >Data de Falecimento do Instituidor da Pensão</label
              >
              <input
                type="text"
                id="data_falecimento_pensao"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.data_falecimento_pensao"
                name="data_falecimento_pensao"
                placeholder="Data de Falecimento do Instituidor da Pensão"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="data_nascimento_pensao" style="font-size: 14px"
                >Data de Nascimento do Instituidor da Pensão</label
              >
              <input
                type="text"
                id="data_nascimento_pensao"
                class="form-control"
                mask="00/00/0000"
                [(ngModel)]="servidor.data_nascimento_pensao"
                name="data_nascimento_pensao"
                placeholder="Data de Nascimento do Instituidor da Pensão"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 3"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome_pensao" style="font-size: 14px"
                >Nome do Instituidor</label
              >
              <input
                type="text"
                id="nome_pensao"
                class="form-control"
                [(ngModel)]="servidor.nome_pensao"
                name="nome_pensao"
                placeholder="Nome do Instituidor"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="matricula_pensao" style="font-size: 14px"
                >Matrícula do Instituidor</label
              >
              <input
                type="text"
                id="matricula_pensao"
                class="form-control"
                [(ngModel)]="servidor.matricula_pensao"
                name="matricula_pensao"
                placeholder="Matrícula do Instituidor"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="pis_pasep" style="font-size: 14px"
                >PIS do Instituidor</label
              >
              <input
                type="text"
                id="pis_pasep"
                class="form-control"
                [(ngModel)]="servidor.pis_pensao"
                mask="0*"
                name="pis_pasep"
                placeholder="PIS do Instituidor"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="cpf_pensao" style="font-size: 14px"
                >CPF do Instituidor</label
              >
              <input
                type="text"
                id="cpf_pensao"
                class="form-control"
                [(ngModel)]="servidor.cpf_pensao"
                name="cpf_pensao"
                placeholder="CPF do Instituidor"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="form-row"
        *ngIf="servidor && servidor.status && servidor.status == 4"
      >
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="motivo_exoneracao" style="font-size: 14px"
                >Motivo Exoneração</label
              >
              <input
                type="text"
                id="motivo_exoneracao"
                class="form-control"
                [(ngModel)]="servidor.motivo_exoneracao"
                name="motivo_exoneracao"
                placeholder="Motivo Exoneração"
                required
                aria-invalid="false"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modal.dismiss('Cancel click')"
    >
      Voltar
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="disableServidor()"
      (click)="cadastrarServidor(modal)"
    >
      Cadastrar
    </button>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>
<ng-template #contentImg>
  <IMG style="width: 100%; height: 100%" [src]="urlToShow" />
</ng-template>
<ng-template #relatorio let-modal>
  <div
    class="modal-header d-flex justify-content-between align-items-center"
    style="border-bottom: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <h4
      class="modal-title mb-0"
      style="color: #333; font-weight: 500; font-size: 24px"
    >
      Relatório do Servidor
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body" style="padding: 0">
    <div
      id="print-section"
      style="
        background: white;
        padding: 2rem;
        font-family: Arial, sans-serif;
        color: #333;
      "
    >
      <!-- Cabeçalho centralizado -->
      <div style="text-align: center; margin-bottom: 2rem">
        <h1
          style="
            color: #16a085;
            font-size: 40px;
            font-weight: 500;
            margin: 0 0 0.5rem 0;
          "
        >
          Prefeitura Municipal de {{ nomeCidade }}
        </h1>
        <p
          style="
            color: #666;
            margin: 0;
            font-size: 20px;
            line-height: 1.4;
            font-family: 'Montserrat', Arial, sans-serif;
          "
          *ngIf="servidor.inicio_atendimento"
        >
          Você participou do censo previdenciário
          {{ getYear(servidor.inicio_atendimento) }} do regime próprio de
          previdência social<br />
          no município de {{ nomeCidade }}.
        </p>
      </div>

      <!-- Informações básicas em formato tabular -->
      <div style="margin-bottom: 2rem">
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.inicio_atendimento"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Início do Atendimento:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.inicio_atendimento) }}]</span
          >
        </div>
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.fim_atendimento"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Fim do Atendimento:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >[{{ beautifulDate(servidor.fim_atendimento) }}]</span
          >
        </div>
        <div
          style="display: flex; margin-bottom: 1rem"
          *ngIf="servidor.matricula"
        >
          <span
            style="
              color: #333;
              font-weight: normal;
              font-size: 20px;
              font-family: monospace;
              width: 30%;
            "
            >Matrícula:</span
          >
          <span
            style="
              font-family: monospace;
              font-weight: 500;
              font-size: 20px;
              width: 70%;
            "
            >{{ servidor.matricula }}</span
          >
        </div>
      </div>

      <!-- Linha separadora -->
      <hr
        style="
          border: none;
          height: 1px;
          background-color: #ddd;
          margin: 2rem 0;
        "
      />

      <!-- Seção de informações do servidor -->
      <div style="display: flex; align-items: flex-start; gap: 2rem">
        <!-- Informações do servidor -->
        <div style="flex: 1">
          <h2
            style="
              color: #333;
              font-size: 24px;
              font-weight: 600;
              margin: 0 0 1.5rem 0;
            "
          >
            Informações do Servidor
          </h2>

          <!-- Layout tabular simples -->
          <div style="margin-bottom: 1rem">
            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.nome"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >NOME</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.nome }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.cpf"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >CPF</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.cpf | mask : "000.000.000-00" }}</span
              >
            </div>

            <div style="display: flex; margin-bottom: 1rem" *ngIf="servidor.rg">
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >IDENTIDADE</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.rg }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.data_nascimento"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE NASCIMENTO</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ beautifulDateSimple(servidor.data_nascimento) }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.status"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >STATUS</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.status }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.estado_civil"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >ESTADO CIVIL</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.estado_civil }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.estado_naturalidade"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >NATURALIDADE</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.estado_naturalidade
                }}<span *ngIf="servidor.cidade_naturalidade">
                  - {{ servidor.cidade_naturalidade }}</span
                ></span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.escolaridade"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >ESCOLARIDADE</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.escolaridade }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.pis_pasep"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >PIS</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.pis_pasep }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.telefone"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >TELEFONE</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.telefone }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.cargo"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >CARGO</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.cargo }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.data_ingresso_ente"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE ADMISSÃO</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ beautifulDateSimple(servidor.data_ingresso_ente) }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.carga_horaria"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >CARGA HORÁRIA</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.carga_horaria }} H</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.salario"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
              >
                <span *ngIf="servidor.statusNumero == 1">SALÁRIO BASE</span>
                <span *ngIf="servidor.statusNumero == 2"
                  >VALOR DA APOSENTADORIA</span
                >
                <span *ngIf="servidor.statusNumero == 3"
                  >VALOR DO BENEFÍCIO</span
                >
              </span>
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ formatToBRLCurrency(servidor.salario) }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="servidor.statusNumero == 1 && servidor.idade_aposentadoria"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >PROVÁVEL IDADE DE APOSENTADORIA</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ servidor.idade_aposentadoria }} anos</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="
                servidor.statusNumero == 2 && servidor.concessao_aposentadoria
              "
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE CONCESSÃO DA APOSENTADORIA</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{
                  beautifulDateSimple(servidor.concessao_aposentadoria)
                }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="
                servidor.statusNumero == 2 &&
                servidor.data_ingresso_servico_publico
              "
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DATA DE INGRESSO NO SERVIÇO PÚBLICO</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{
                  beautifulDateSimple(servidor.data_ingresso_servico_publico)
                }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="tempoTotalCadastrado > 0"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DIAS CADASTRADOS</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ tempoTotalCadastrado }}</span
              >
            </div>

            <div
              style="display: flex; margin-bottom: 1rem"
              *ngIf="tempoFiltradoCadastrado > 0"
            >
              <span
                style="
                  color: #666;
                  font-weight: normal;
                  width: 30%;
                  font-size: 16px;
                  font-family: monospace;
                "
                >DIAS CADASTRADOS INSS</span
              >
              <span
                style="
                  color: #333;
                  font-weight: 500;
                  font-size: 16px;
                  font-family: monospace;
                  width: 70%;
                "
                >{{ tempoFiltradoCadastrado }}</span
              >
            </div>
          </div>
        </div>

        <!-- Foto do servidor no canto direito superior -->
        <div style="flex-shrink: 0">
          <div
            style="
              width: 150px;
              height: 150px;
              border-radius: 50%;
              overflow: hidden;
              background: #f0f0f0;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 2px solid #ddd;
            "
          >
            <img
              *ngIf="servidor && servidor.imagem"
              [src]="servidor.imagem"
              alt="Foto do servidor"
              style="width: 100%; height: 100%; object-fit: cover"
            />
            <div
              *ngIf="!servidor || !servidor.imagem"
              style="color: #999; font-size: 12px; text-align: center"
            >
              Sem foto
            </div>
          </div>
        </div>
      </div>

      <!-- Linha separadora -->
      <hr
        style="
          border: none;
          height: 1px;
          background-color: #ddd;
          margin: 2rem 0;
        "
      />

      <!-- Seção de Dependentes -->
      <div>
        <h2
          style="
            color: #333;
            font-size: 24px;
            font-weight: 600;
            margin: 0 0 1.5rem 0;
          "
        >
          Dependentes
        </h2>

        <div
          *ngIf="dependentesToShow && dependentesToShow.length > 0"
          style="margin-bottom: 2rem"
        >
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              font-family: monospace;
              font-size: 16px;
            "
          >
            <thead>
              <tr style="border-bottom: 2px solid #ddd">
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Nome
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  CPF
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Tipo
                </th>
                <th
                  style="
                    padding: 1rem;
                    text-align: center;
                    color: #666;
                    font-weight: normal;
                  "
                >
                  Idade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let dependente of dependentesToShow"
                style="border-bottom: 1px solid #eee"
              >
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.nome }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.cpf | mask : "000.000.000-00" }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.tipo_dependencia_label }}
                </td>
                <td
                  style="
                    padding: 1rem;
                    color: #333;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  {{ dependente.idade }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          *ngIf="!dependentesToShow || dependentesToShow.length == 0"
          style="
            text-align: center;
            padding: 2rem;
            color: #666;
            font-style: italic;
          "
        >
          Nenhum dependente cadastrado.
        </div>
      </div>
    </div>
  </div>

  <!-- Rodapé com botões -->
  <div
    class="modal-footer d-flex justify-content-between"
    style="border-top: 1px solid #dee2e6; padding: 1rem 1.5rem"
  >
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.dismiss('Close click')"
      style="padding: 0.5rem 1.5rem; border-radius: 4px"
    >
      Fechar
    </button>

    <button
      type="button"
      class="btn"
      printTitle="Relatório do Servidor"
      printDelay="1000"
      printSectionId="print-section"
      ngxPrint
      style="
        background: #16a085;
        border-color: #16a085;
        color: white;
        padding: 0.5rem 1.5rem;
        border-radius: 4px;
      "
    >
      Imprimir
    </button>
  </div>

  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
